import { SprintDashboard } from '@devd-client/devd/components';
import { AuthActionTypes, getUser, useAuth } from '@devd-client/devd/auth';

const SprintVelocity = () => {
  const [appState, dispatch] = useAuth();

  return (
    <SprintDashboard
      appState={appState}
      dispatch={dispatch}
      AuthActionTypes={AuthActionTypes}
      getUser={getUser}
    />
  );
};

export default SprintVelocity;
